// src/components/SidebarConstants.js

// Complete list of unit options from utilities.py
export const unitOptions = [
    "UNIT Number",
    "UNIT-1   ---  SHANTINAGAR",
    "UNIT-2   ---   MATHIKERE ",
    "UNIT-3   ---  DEVEGOWDA PETROL BUNK",
    "UNIT-4   ---  FRAZER TOWN ",
    "UNIT-5   ---  VIJAYANGAR",
    "UNIT-6   ---  BANNERGHATTA ROAD",
    "UNIT-7   ---  INDIRANAGAR",
    "UNIT-8   ---  MYSURU (Ballal circle) ",
    "UNIT-9   ---  MANGALORE",
    "UNIT-10   ---  ELECTRONIC CITY",
    "UNIT-11   ---  J.P. NAGAR 7TH PHASE ",
    "UNIT-12   ---  Yelahanka New Town ",
    "UNIT-13   --- WHITEFIELD ",
    "UNIT-14   ---  BTM LAYOUT",
    "UNIT-15   ---   KENGERI SATELLITE TOWN",
    "UNIT-16   ---   UTTARAHALLI HOBLI ",
    "UNIT-17   ---  HYDERABAD (HABSIGUDA)   ",
    "UNIT-18   ---  HSR LAYOUT ",
    "UNIT-19   --- JAYANAGAR(3rd block)  ",
    "UNIT-20   --- CHENNAI(VADAPALANI) ",
    "UNIT-21   ---   HORAMAVU MAIN ROAD ",
    "UNIT-22   ---   MYSURU (Vijayanagar 1st stage)",
    "UNIT-23   ---  KAGGDASPURA MAIN ROAD",
    "UNIT-24   ---  BASAVESHWAR NAGAR ",
    "UNIT-25   ---    K R PURAM",
    "UNIT-26   ---  WHITEFIELD MAIN ROAD ",
    "UNIT-27   --- R K HEGDE NAGAR  ",
    "UNIT-28   ---  HESARAGHATTA MAIN ROAD ",
    "UNIT-29   --- CHENNAI (KILPAUK) ",
    "UNIT-30   --- NAGARABHAVI 2ND STAGE ",
    "UNIT-31   ---  CHENNAI (ANNA NAGAR) ",
    "UNIT-32   --- LAKSHMINARAYANAPURA  ",
    "UNIT-33   --- HYDERABAD (KUKATPALLY) ",
    "UNIT-34   ---  KORAMANGALA ",
    "UNIT-35   --- UTTARAHALLI MAIN ROAD ",
    "UNIT-36   --- CHENNAI (MEDAVAKKAM) ",
    "UNIT-37   --- CHENNAI (PERAMBUR) ",
    "UNIT-38   --- KANAKPURA MAIN ROAD ",
    "UNIT-39   ---  MADURAI",
    "UNIT-40   ---  BYADARAHALLI",
    "UNIT-41   ---  HANUMANTHNAGAR",
    "UNIT-42   --- HRBR LAYOUT",
    "UNIT-43   --- HOSA ROAD",
    "UNIT-44   --- KUVEMPUNAGAR",
    "UNIT-45   --- VIZAG",
    "UNIT-46   --- RANEBENNUR",
    "UNIT-47   --- ANANTHAPUR",
    "UNIT-48   ---  SARJAPUR",
    "UNIT-49   ---  KOLAR",
    "UNIT-50   ---  MALLESHWARAM",
    "UNIT-51   ---  KONDAPURA",
];

// Complete list of doctor options from utilities.py
export const doctorOptions = [
    "Doctor Name",
    "Dr Aparna S Namboothiri",
    "Dr Bharathi",
    "Dr Deepthi",
    "Dr Prathibha P",
    "Dr Rashmi",
    "Dr Rupa K R",
    "Dr Sushma Pulivarthi",
    "Dr Uthkal M P",
    "Dr Vinod Kumar A R",
];

export const reportTypeOptions = [
    "Mandible - Basic Report",
    "Maxilla - Basic Report",
    "Virtual Implant"
];